import { useNavigate } from "react-router-dom";

const MapBanner = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div>
            <span className="text-amber-500 text-sm font-semibold uppercase tracking-widest">Yerel Rehber</span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mt-3 mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
              Kalabalıktan Uzak,<br />Gerçek Türkiye
            </h2>
            <p className="text-stone-600 text-sm leading-relaxed mb-6">
              Popüler turist rotalarının gölgesinde kalan, yerel halkın yıllardır bildiği
              gizli köşeleri keşfedin. Her destinasyon, editörlerimiz tarafından bizzat
              ziyaret edilerek titizlikle değerlendirilmiştir.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                { icon: "ri-checkbox-circle-line", text: "Her yer editörlerimiz tarafından bizzat ziyaret edilmiştir" },
                { icon: "ri-checkbox-circle-line", text: "Yerel halkın önerileri ve kimsenin bilmediği ipuçları" },
                { icon: "ri-checkbox-circle-line", text: "Güncel, doğrulanmış bilgiler ve pratik seyahat tavsiyeleri" },
                { icon: "ri-checkbox-circle-line", text: "Zengin fotoğraf galerileri ve kapsamlı içerikler" },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className={`${item.icon} text-amber-500`}></i>
                  </div>
                  <span className="text-stone-600 text-sm">{item.text}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => navigate("/places")}
                className="bg-amber-500 hover:bg-amber-600 text-white font-semibold text-sm px-6 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Yerleri Keşfet
              </button>
              <button
                onClick={() => navigate("/articles")}
                className="border border-stone-300 hover:border-amber-500 text-stone-700 hover:text-amber-600 font-semibold text-sm px-6 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Makaleleri Oku
              </button>
            </div>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-3">
              <div className="h-48 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Turkey%20Halfeti%20Euphrates%20river%20boat%20tour%20romantic%20scenic%20water%20reflection%20village&width=300&height=200&seq=banner1&orientation=portrait"
                  alt="Halfeti"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="h-32 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Turkey%20Gaziantep%20baklava%20pistachio%20sweets%20traditional%20food%20close%20up&width=300&height=140&seq=banner2&orientation=landscape"
                  alt="Gaziantep"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="space-y-3 mt-6">
              <div className="h-32 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Turkey%20Safranbolu%20Ottoman%20wooden%20house%20historic%20street%20cobblestone&width=300&height=140&seq=banner3&orientation=landscape"
                  alt="Safranbolu"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="h-48 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Turkey%20Ayder%20plateau%20Rize%20green%20mountains%20waterfall%20wooden%20houses%20summer&width=300&height=200&seq=banner4&orientation=portrait"
                  alt="Ayder"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapBanner;
